import { useCallback } from "react";
import {
  identifyUser,
  setTag,
  trackEvent,
  setCookieConsent,
  upgradeSession,
} from "../Services/clarity-config";

/**
 * Custom hook for Microsoft Clarity analytics
 * Provides easy access to all Clarity functions throughout the app
 */
export const useClarity = () => {
  // Identify a user (useful for hackathon participants)
  const identify = useCallback(
    (
      customId,
      customSessionId = null,
      customPageId = null,
      friendlyName = null
    ) => {
      identifyUser(customId, customSessionId, customPageId, friendlyName);
    },
    []
  );

  // Set custom tags (e.g., participant type, team name, etc.)
  const tag = useCallback((key, value) => {
    setTag(key, value);
  }, []);

  // Track custom events (e.g., "application_submitted", "team_formed", etc.)
  const event = useCallback((eventName) => {
    trackEvent(eventName);
  }, []);

  // Set cookie consent
  const consent = useCallback((hasConsent = true) => {
    setCookieConsent(hasConsent);
  }, []);

  // Upgrade session for important interactions
  const upgrade = useCallback((reason) => {
    upgradeSession(reason);
  }, []);

  return {
    identify,
    tag,
    event,
    consent,
    upgrade,
  };
};

export default useClarity;
